import React from 'react';

import { Button, FunctionField, useTranslate } from 'react-admin';
import DetailsIcon from '@material-ui/icons/InfoOutlined';

import QuickPreview from 'components/CustomDrawer';

import PreviewDialog from './PreviewDialog';
import { IconButton, Tooltip } from '@material-ui/core';


const QuickDetailsButton = ({ record }) => {
	const translate = useTranslate();

	const PreviewOpenButton = (openButtonProps) => (
		<Tooltip title={translate("osfc.buttons.external_details")} placement="top">
			<IconButton aria-label="Info" size="small" {...openButtonProps}>
				<DetailsIcon />
			</IconButton>
		</Tooltip>
	);

	return (
		<QuickPreview 
			contentProps={{ record }}
			ContentComponent={PreviewDialog}
			PreviewOpenButtonComponent={PreviewOpenButton}
		/>
	);
};


const PreviewDetailsButton = (props) => (
	<FunctionField
		{...props}
		align='center'
		render={record => <QuickDetailsButton record={record} />}
	/>
);


export default PreviewDetailsButton;
